import {IParticipant} from '../contact/ContactPicker'

export const HR_INTERVIEW_PATH = '/hr/interview'

export type InterviewStatus = 'PLANNED' | 'COMPLETED' | 'CANCELLED'

export interface IInterviewNote {
  id: string
  text: string
  authorName?: string | null
  createdDate?: string
}

/** InterviewDto */
export interface IInterviewModel {
  id: string
  trackingId?: string | null
  applyJobId?: string | null
  candidateId?: string | null
  candidateName: string
  candidateEmail?: string | null
  jobTitle?: string | null
  title: string
  description?: string | null
  start: string
  end: string
  meetLink?: string | null
  organizerUserName?: string | null
  participants: IParticipant[]
  mailTemplateName?: string | null
  status: InterviewStatus
  completedAt?: string | null
  cancelReason?: string | null
  cancelledAt?: string | null
  noteCount: number
  notes?: IInterviewNote[] | null
  createdDate?: string
}

export interface IInterviewCreateRequest {
  trackingId: string
  title: string
  description: string
  start: string
  end: string
  participants: IParticipant[]
  mailTemplateId: string | null
  notifyCandidate: boolean
  createMeet: boolean
  meetingLink: string | null
}

export interface IInterviewFilters {
  q: string
  status: InterviewStatus | ''
  from: string
  to: string
}

export const INTERVIEW_STATUS_LABEL: Record<InterviewStatus, string> = {
  PLANNED: 'Planlandı',
  COMPLETED: 'Gerçekleşti',
  CANCELLED: 'İptal Edildi',
}

export const INTERVIEW_STATUS_BADGE: Record<InterviewStatus, string> = {
  PLANNED: 'badge-light-primary',
  COMPLETED: 'badge-light-success',
  CANCELLED: 'badge-light-danger',
}

export const INTERVIEW_STATUS_OPTIONS = (Object.keys(INTERVIEW_STATUS_LABEL) as InterviewStatus[]).map((value) => ({
  value,
  label: INTERVIEW_STATUS_LABEL[value],
}))

/** "2026-10-08T14:00:00" → "08.10.2026" */
export const formatDate = (value?: string | null) => {
  if (!value) return '-'
  const [year, month, day] = value.substring(0, 10).split('-')
  return `${day}.${month}.${year}`
}

/** Mülakat zamanı: "08.10.2026 14:00 - 15:00" */
export const interviewTimeRange = (interview: Pick<IInterviewModel, 'start' | 'end'>) =>
  `${formatDate(interview.start)} ${interview.start.substring(11, 16)} - ${interview.end.substring(11, 16)}`
